<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')">
          <CloseSvg />
        </a>
      </div>
      <img
        style="width:42px;margin-bottom:10px"
        src="/assets/img/svg/alert.svg"
      />
      <div class="title">לתשומת ליבך,</div>
      <div>
        מאחר ונבחר קוד ניתוח זהה, יש להגדיר 'צד' עבור כל שורת פעולה.
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";

export default {
  name: "SurgSidesErr",
  components: {
    CloseSvg
  }
};
</script>
